export default {
  // Page title
  'page.title': 'Мировые Часы',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Местное Время',
  'timezone.currentTime': 'Текущее Время',
  'timezone.label': 'Часовой Пояс',
  'timezone.title': 'Часовой Пояс {{city}}',
  'timezone.localClockOffset': 'Местное Смещение Времени',
  'timezone.timeZone': 'Часовой пояс',
  'timezone.today': 'Сегодня',
  'timezone.hours': 'Ч',
  'timezone.standardTimeZone': 'Стандартный Часовой Пояс',
  'timezone.daylightSavingTimeZone': 'Летний Часовой Пояс',

  // City names (keeping English as standard)
  'city.newYork': 'Нью-Йорк',
  'city.london': 'Лондон',
  'city.paris': 'Париж',
  'city.tokyo': 'Токио',
  'city.sydney': 'Сидней',
  'city.dubai': 'Дубай',
  'city.singapore': 'Сингапур',
  'city.hongKong': 'Гонконг',
  'city.shanghai': 'Шанхай',
  'city.beijing': 'Пекин',
  'city.mumbai': 'Мумбаи',
  'city.moscow': 'Москва',
  'city.berlin': 'Берлин',
  'city.losAngeles': 'Лос-Анджелес',
  'city.chicago': 'Чикаго',
  'city.toronto': 'Торонто',
  'city.vancouver': 'Ванкувер',
  'city.brasilia': 'Бразилиа',
  'city.buenosAires': 'Буэнос-Айрес',
  'city.cairo': 'Каир',
  'city.istanbul': 'Стамбул',

  // How to use
  'howto.title': 'Как Использовать Онлайн Мировые Часы',
  'howto.step1': 'Этот сайт мировых часов показывает текущее время и мировое время для любого города по всему миру. Проверяйте часовые пояса, разницу мирового времени и международное время мгновенно по всему миру.',
  'howto.step2': 'Главная страница мировых часов отображает ваше местное время, а также несколько мировых часов для крупных городов. Каждый мировой часовой пояс показывает точное время, дату и информацию о смещении часового пояса.',
  'howto.step3': 'Нажмите на любое название города в списке мировых часов, чтобы просмотреть подробную информацию о часовом поясе. Каждая страница мирового времени предоставляет полные данные о часовом поясе и текущем времени для этого местоположения.',
  'howto.step4': 'Используйте поиск мировых часов, чтобы найти время в любом городе мира. Идеально подходит для проверки мировых часовых поясов, координации международного времени и управления глобальным временем.',

  // User reviews
  'reviews.title': 'Отзывы Пользователей',
  'reviews.globalBusiness': 'Необходим для международного бизнеса! Легко координировать время встреч в разных часовых поясах, очень удобно.',
  'reviews.travelBlogger': 'Обязателен для планирования путешествий! Всегда знаю местное время в месте назначения, больше никакой путаницы с часовыми поясами.',
  'reviews.remoteTeam': 'Идеально подходит для удаленной командной работы! Легко увидеть, когда коллеги в разных странах работают.',
  'reviews.internationalFamily': 'Отлично подходит для связи с семьей за границей! Всегда знаю лучшее время для звонка, чтобы не потревожить их сон.',
  'reviews.managerZhang': 'Как менеджер проекта, это помогает мне более эффективно планировать встречи с глобальными клиентами.',

  // User names
  'user.globalBusiness': 'Глобальный Бизнес',
  'user.travelBlogger': 'Блогер-Путешественник',
  'user.remoteTeam': 'Удаленный Разработчик',
  'user.internationalFamily': 'Международная Семья',
  'user.managerZhang': 'Менеджер Чжан',

  // Keywords
  'keywords.worldclock': 'мировые часы часовые пояса международное время который час',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Время по Странам',
  'timeIn': 'Время в',
  'cities': 'городов',
  'available': 'доступно',
  'citiesIn': 'Города в',
  'viewDetails': 'Посмотреть детали',
  'countryNotFound': 'Страна не найдена',
  'backToWorldClock': 'Вернуться к Мировым Часам',
  'cityNotFound': 'Город не найден',
  'popularCitiesIn': 'Популярные Города в',
  'currentTime': 'Текущее Время',
};
